// extracted by mini-css-extract-plugin
module.exports = {"support":"support_support__tjxvc"};